var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealPageLogoMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_17895)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 1.59086,
    fill: "#EE7755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 8.01296C19.2 9.78684 17.7669 11.226 15.999 11.226C14.2311 11.226 12.8 9.78684 12.8 8.01296C12.8 6.23907 14.2331 4.79993 16.001 4.79993C17.7669 4.79993 19.2 6.23907 19.2 8.01296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 22.3998C11.2 24.1665 9.76685 25.5998 7.99899 25.5998C6.23112 25.5998 4.79999 24.1665 4.79999 22.3998C4.79999 20.6331 6.23312 19.1998 8.00099 19.1998C9.76886 19.1998 11.2 20.6311 11.2 22.3998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 22.3998C27.2 24.1665 25.7669 25.5998 23.999 25.5998C22.2331 25.5998 20.8 24.1665 20.8 22.3998C20.8 20.6331 22.2331 19.1998 23.999 19.1998C25.7689 19.1998 27.2 20.6311 27.2 22.3998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_17895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealPageLogoMedium);
export default __webpack_public_path__ + "static/media/real-page-logo-medium.8165b22c.svg";
export { ForwardRef as ReactComponent };